import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { AssetField } from '@/lib/asset'

import { PhnxAvatar } from './Avatar'
import { AvatarProps } from './Avatar'

interface AvatarBlokProps {
  blok: {
    asset: AssetField
    size: AvatarProps['size']
    style: AvatarProps['style']
    title: AvatarProps['title']
    subtitle: AvatarProps['subtitle']
    link: any
  } & SbBlokData
}

const Avatar: FC<AvatarBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxAvatar
        asset={{
          src: blok.asset.filename,
          alt: blok.asset.alt,
        }}
        size={blok.size}
        style={blok.style}
        title={blok.title}
        subtitle={blok.subtitle}
        link={blok?.link?.cached_url}
      />
    </div>
  )
}

export default Avatar
